import React from "react";
import { Link } from "react-router-dom";

import { ApolloProvider } from "@apollo/client";
import client from "client";

import DefaultQuery from "./DefaultQuery";
import { QUERY_USER } from "./UserQueries";

import UpdateUser from "./UpdateUser";

import Heading from "components/Elements/Heading.js";

const UserEditContainer = (props) => {
  const email = props.match.params.email;
  return (
    <div className="container-wrapper">
      <div className="container-fluid">
        <main className="container-main">
          <Link to="/settings/users">
            {" "}
            <i className="fas fa-chevron-circle-left" /> Back
          </Link>

          <Heading size={3} className={"mb-4 mt-4"}>
            Update User
          </Heading>

          <ApolloProvider client={client}>
            <DefaultQuery
              query={QUERY_USER}
              variables={{
                search: email,
                tenantID: parseInt(localStorage.defaultTenantID),
              }}
            >
              {({ data: { users, roles } }) => (
                <UpdateUser data={users} roles={roles} />
              )}
            </DefaultQuery>
          </ApolloProvider>
        </main>
      </div>
    </div>
  );
};

export default UserEditContainer;
